<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Select Date</mat-label>
        <input type="date" [(ngModel)]="selected_date"  (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 11%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_date == null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" style="margin-top: 25px;" (click)="downloadClicked()"><i class="material-icons">
          picture_as_pdf
          </i> Download Report</button>
      </div>
    </div>
    <!-- <div class="row" *ngIf="document_file!== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
                picture_as_pdf
              </i> Download report</button>
          </div>
          <div class="col-4">
            <button mat-button class="button-class"><i class="material-icons">
                get_app
              </i> Download Excel</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>

</section>
